function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGreyIconDistributor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "icon/distributor",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 234",
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1220",
    d: "M16562.5 13286.666h-6.332a1.05 1.05 0 0 1-1.059-1.037v-6.23a.286.286 0 0 1 0-.061l-2.113-3.666v-1.646a5.884 5.884 0 0 1 1.658-4.076 6.437 6.437 0 0 1 4.064-1.943h.578c.074 0 .232 0 .557-.006h.021a6.455 6.455 0 0 1 4.107 1.93 5.862 5.862 0 0 1 1.68 4.1v1.646l-2.111 3.66v6.296a1.048 1.048 0 0 1-1.05 1.033zm-3.7-3.639v1.043h1.055v-1.043h1.061V13282h-1.061v-1.041h-1.055v1.041h-1.055v1.031zm-4.469-7.355 1.557 2.727a.949.949 0 0 1 .275-.037h6.332a1.173 1.173 0 0 1 .271.033l1.559-2.723h-9.994zm5-6.84a5.247 5.247 0 0 0-1.586 2.559 12.193 12.193 0 0 0-.416 3.441h4a12.093 12.093 0 0 0-.416-3.441 5.251 5.251 0 0 0-1.577-2.559z",
    transform: "translate(-16547.334 -13265.333)",
    style: {
      fill: "#808285"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyIconDistributor);
export default __webpack_public_path__ + "static/media/greyIconDistributor.60fae6c1.svg";
export { ForwardRef as ReactComponent };